'use strict'
var twentyninetimes = twentyninetimes || {}
const mapStyles = [
  {
    featureType: 'all',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.text.fill',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.country',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#fff2df',
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.province',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#fff2df',
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#f3f4f4',
      },
    ],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry',
    stylers: [
      {
        weight: 0.9,
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape.natural',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#fff2df',
      },
    ],
  },
  {
    featureType: 'landscape.natural.landcover',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#fff2df',
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape.natural.terrain',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#fff2df',
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry.fill',
    stylers: [
      {
        visibility: 'off',
      },
      {
        color: '#fff2df',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'all',
    stylers: [
      {
        visibility: 'off',
      },
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'all',
    stylers: [
      {
        visibility: 'simplified',
      },
      {
        color: '#ff9d00',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'all',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#ff9d00',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'all',
    stylers: [
      {
        color: '#ff9d00',
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'all',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#7fc8ed',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#abd3dd',
      },
    ],
  },
]
unitas.hotelsmap =
  unitas.hotelsmap ||
  (function () {
    var mapList = document.querySelectorAll('.js-block-map-item')
    function init() {
      mapList.forEach((map) => {
        const markers = []
        const shops = [...map.querySelectorAll('.js-map-item')].map(
          (item, index) => {
            return {
              id: `map-item-${index}`,
              name: item.getAttribute('data-name'),
              lat: item.getAttribute('data-lat'),
              lng: item.getAttribute('data-lng'),
              url: item.getAttribute('href'),
            }
          }
        )
        const mapElement = map.querySelector('.js-block-map')
        if (mapElement) {
          var dataMaxZoom = mapElement.dataset.maxZoom
          var mapOptions = {
            disableDefaultUI: true,
            zoomControl: false,
            maxZoom: dataMaxZoom,
            // styles: mapStyles
          }
          const googleMap = new google.maps.Map(mapElement, mapOptions)
          var bounds = new google.maps.LatLngBounds()
          shops.map((shop) => {
            if (!shop.lat || !shop.lng) {
              return null
            }
            var latLng = new google.maps.LatLng(
              parseFloat(shop.lat),
              parseFloat(shop.lng)
            )
            bounds.extend(latLng)
            var marker = new google.maps.marker.AdvancedMarkerElement({
              // icon: "/wp-content/themes/unitas/__dist/images/pin.png",
              // icon: ' ',
              position: latLng,
              map: googleMap,
              id: shop.id,
              title: shop.name,
              // animation: google.maps.Animation.DROP,
              // label: {
              //   text: shop.name,
              //   color: '#fff',
              //   className: 'accommodation-map__label',
              // },
            })
            markers.push(marker)
          })

          if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
            var extendPoint1 = new google.maps.LatLng(
              bounds.getNorthEast().lat() + 0.01,
              bounds.getNorthEast().lng() + 0.01
            )
            var extendPoint2 = new google.maps.LatLng(
              bounds.getNorthEast().lat() - 0.01,
              bounds.getNorthEast().lng() - 0.01
            )
            bounds.extend(extendPoint1)
            bounds.extend(extendPoint2)
          }
          googleMap.fitBounds(bounds)
        }
      })
    }
    return {
      init,
    }
  })()
